<template>
    <div>
        <code>{{formularios}}</code>
    </div>
</template>

<script>
    import {db} from '@/firebase'

    export default {
        data() {
            return {
                formularios: []
            }
        },
        mounted() {
            db.collection('formularios').get()
                .then(snapshot => {
                    snapshot.docs.forEach(doc => this.formularios.push(doc.data()))
                })
        }
    }
</script>